import React from 'react'
import { Box } from '@mui/material'
import { MY_BUSINESS_ROUTES } from '@constants/routes'
import { dsColorNew } from '@palette'

import MappingAdminPage from '../_shared/MappingAdminPage'

export default function CategoryMappingPage({ embedded = false }) {
	return (
		<MappingAdminPage
			embedded={embedded}
			icon="car"
			title={MY_BUSINESS_ROUTES.CATEGORY_ADMIN_TITLE}
			subtitle={MY_BUSINESS_ROUTES.CATEGORY_ADMIN_SUBTITLE}
			listEndpoint="/api/my-business/admin/category-mapping"
			rowKey="sipp_code"
			rowKeyParam="pms_sipp_code"
			pmsListKey="categories"
			valueField="ps_acriss_code"
			psOptionsKey="ps_options"
			psOptionId="code"
			psOptionLabel={(opt) => (
				<Box component="span" sx={{ fontWeight: 700, letterSpacing: '0.04em' }}>
					{opt.code}
				</Box>
			)}
			pmsColumns={[
				{ label: 'PMS SIPP', cell: (r) => (
					<Box sx={{ fontWeight: 700, color: dsColorNew.textTitle,
					           letterSpacing: '0.04em' }}>
						{r.sipp_code}
					</Box>
				)},
				{ label: 'Vehicle class', cell: (r) => r.vehicle_class || '' },
			]}
			footerHint="Map PMS SIPP codes to Price Seeker ACRISS. Codes that match 1:1 (CDAR↔CDAR, EDMR↔EDMR, …) are auto-mapped silently when the page loads; the remaining ones you assign manually."
		/>
	)
}
